'use client';

/**
 * DomainShell.tsx — felles sideramme for de fire domenesidene
 *
 * Header med meny, <main id="innhold"> og footer med kolonner (inSuite + sidens egne
 * seksjoner). Hver side leverer innholdet (hero, seksjoner) som children.
 */

import type { ReactNode } from 'react';
import LandingFooter from '@/components/landing/LandingFooter';
import LandingHeader from '@/components/landing/LandingHeader';
import { MASTHEAD_CONTENT } from '@/components/landing/masthead-content';
import landingStyles from '@/sections/landing/landing.module.css';
import type { Locale } from '@/types/landing';
import type { DomainSharedContent } from '@/types/domain';
import type { ProductSectionNav } from '@/types/product';

interface DomainShellProps {
  shared: DomainSharedContent;
  sectionNav: ProductSectionNav;
  locale: Locale;
  onLocaleChange: (locale: Locale) => void;
  children: ReactNode;
}

export default function DomainShell({ shared, sectionNav, locale, onLocaleChange, children }: DomainShellProps) {
  return (
    <div className={landingStyles.page}>
      <LandingHeader ui={shared.ui} menu={MASTHEAD_CONTENT[locale]} locale={locale} onLocaleChange={onLocaleChange} />
      <main id="innhold" className={landingStyles.main}>
        {children}
      </main>
      <LandingFooter
        tagline={shared.footer.tagline}
        legal={shared.footer.legal}
        columns={[
          {
            heading: shared.footer.platformLabel,
            links: [
              { label: 'inSuite', href: '/' },
              { label: shared.ui.login, href: '/login' },
            ],
          },
          {
            heading: shared.footer.sectionsLabel,
            links: sectionNav.items.map((item) => ({ label: item.label, href: `#${item.id}` })),
          },
        ]}
      />
    </div>
  );
}
